import React, { useEffect, useState, useRef } from "react";
import { Row, Col, Button, Input, Label } from "reactstrap";
import * as Icon from "react-feather";
import classNames from "classnames";

import CustomInput from "./CustomInput";
import { isUUID } from "../../helpers/utils";

const VIDEO_TYPES = ['LECTURE', 'VIDEOS', 'SEEDS'];

const VideoFilter = ({ onSubmitFilter, loading }) => {

  var videoIdInput = useRef(null);
  var keywordInput = useRef(null);

  const [cancelDebounce, setCancelDebounce] = useState(false);
  const [validateErrors, setValidateErrors] = useState({});

  const [filters, setFilters] = useState({
    keywords: '',
    videoId: '',
    videoOwner: '',
    videoUser: '',
    order: '',
    types: VIDEO_TYPES,
    reload: false,
  });

  const fetching = false;

  const handleKeywordChange = (value) => {
    setFilters({ ...filters, keywords: value });
    setCancelDebounce(false);
  }

  const handleKeywordSubmit = (keywords) => {
    setFilters({ ...filters, keywords: keywords, reload: true });
  };

  const handleVideoIdChange = (value) => {
    if (value && !isUUID(value)) {
      setValidateErrors({
        ...validateErrors,
        videoId: 'Video id must be in uuid format.'
      });
    } else {
      let errors = Object.assign({}, validateErrors);
      delete errors.videoId;

      setValidateErrors({
        ...errors
      });
    }
    setCancelDebounce(false);
    setFilters({ ...filters, videoId: value });
  }

  const handleVideoIdSubmit = (videoId) => {
    setCancelDebounce(true);
    setFilters({ ...filters, videoId: videoId, reload: true });
  };

  const handleInputChange = (value, name) => {
    setFilters({ ...filters, [name]: value });
  }

  const handleInputSubmit = (value, name) => {
    setCancelDebounce(true);
    setFilters({ ...filters, [name]: value, reload: true });
  }

  const handleVideoTypeChange = (option) => {
    if (filters.types.includes(option)) {
      setFilters({ ...filters, types: filters.types.filter((item) => item !== option) });
    } else {
      setFilters({ ...filters, types: [...filters.types, option] });
    }
  }

  const submitFilter = () => {
    if (!filters.keywords && !filters.videoId && !filters.videoOwner && !filters.videoUser) {
      if (keywordInput.current) keywordInput.current.focus();

      return;
    }

    if (validateErrors && validateErrors.videoId) {
      if (videoIdInput.current) videoIdInput.current.focus();

      return;
    }

    setCancelDebounce(true);
    if (onSubmitFilter) onSubmitFilter(filters);
  };

  useEffect(() => {
    if (filters.reload) {
      submitFilter();
      setFilters({ ...filters, reload: false });
    }
  }, [filters.reload]);

  return (
    <>
      <Row className={classNames('video-review-filter')} style={{ transition: 'visibility 0.5s, opacity 0.5s linear' }}>
        <Col lg="2" md="2" xs="2" className="mt-1 mb-1">
          <label htmlFor="" className="mb-0">Video id</label>
        </Col>
        <Col lg="4" md="4" xs="4" className="mt-1 mb-1">
          <div className="item-filter reviewer-filter">
            <div className="d-inline-block ml-2 item-filter__control w-100">
              <CustomInput
                name="videoId"
                className={classNames('w-100', { 'is-invalid': validateErrors.videoId ? true : false })}
                placeholder=""
                disabled={fetching}
                debounceTime={3000}
                cancelDebounce={cancelDebounce}
                onChange={handleVideoIdChange}
                onSubmit={handleVideoIdSubmit}
                innerRef={videoIdInput}
                maxLength="36"
              />
            </div>
          </div>
        </Col>
        <Col lg="2" md="2" xs="2" className="mt-1 mb-1">
          <label htmlFor="" className="mb-0">Video owner</label>
        </Col>
        <Col lg="4" md="4" xs="4" className="mt-1 mb-1">
          <div className="item-filter video-type-filter">
            <div className="d-inline-block ml-2 item-filter__control  w-100">
              <CustomInput
                name="videoOwner"
                value={filters.videoOwner}
                className="w-100"
                placeholder=""
                disabled={fetching}
                debounceTime={3000}
                cancelDebounce={cancelDebounce}
                onChange={handleInputChange}
                onSubmit={handleInputSubmit}
              />
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg="2" md="2" xs="2" className="mt-1 mb-1">
          <label htmlFor="" className="mb-0">Keywords</label>
        </Col>
        <Col lg="4" md="4" xs="4" className="mt-1 mb-1">
          <div className="item-filter">
            <div className="d-inline-block item-filter__control ml-2  w-100">
              <CustomInput
                name="keywords"
                value={filters.keywords}
                className="w-100"
                placeholder="Title, subject, topic..."
                disabled={fetching}
                debounceTime={3000}
                cancelDebounce={cancelDebounce}
                onChange={handleKeywordChange}
                onSubmit={handleKeywordSubmit}
                innerRef={keywordInput}
              />
            </div>
          </div>
        </Col>
        <Col lg="2" md="2" xs="2" className="mt-1 mb-1">
          <label htmlFor="" className="mb-0">Video types</label>
        </Col>
        <Col lg="4" md="4" xs="4" className="mt-1 mb-1">
          <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }} >
            {VIDEO_TYPES.map((option, index) => (
              <div key={index} className="ml-2 w-100">
                <Input
                  type="checkbox"
                  id={`checkbox-${index}`}
                  checked={filters.types.includes(option)}
                  onChange={() => handleVideoTypeChange(option)}
                  className="ml-0"
                />
                <Label for={`checkbox-${index}`} className="ml-4">
                  {option}
                </Label>
              </div>
            ))}
          </div>
        </Col>
      </Row>
      <Row>
        <Col className="mt-1 mb-1 d-flex justify-content-end">
          <Button
            className="ml-3"
            size=""
            disabled={loading}
            onClick={(e) => { setCancelDebounce(true); submitFilter(e); }}
          >
            <Icon.Search className="" style={{ width: '15px', height: '15px', marginTop: '-2px' }} /> Search video
          </Button>
        </Col>
      </Row>
    </>
  )
}

export default React.memo(VideoFilter);